// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentBottom_wrapper__3RSC0"};